<!-- @format -->

<template>
	<v-row class="kpis" dense>
		<v-col v-for="tarjeta in tarjetas" :key="tarjeta.valor" cols="6" md="3">
			<v-card
				outlined
				:ripple="false"
				class="kpi pa-3 d-flex align-center"
				:class="{ 'kpi--activo': activo === tarjeta.valor }"
				:style="activo === tarjeta.valor ? `border-color:${tarjeta.color}` : ''"
				:aria-pressed="String(activo === tarjeta.valor)"
				role="button"
				@click="$emit('filtrar', activo === tarjeta.valor ? 'todas' : tarjeta.valor)"
			>
				<v-avatar :color="tarjeta.color" size="36" class="mr-3 flex-shrink-0">
					<v-icon dark small>{{ tarjeta.icono }}</v-icon>
				</v-avatar>
				<div class="text-left" style="min-width: 0">
					<div class="text-h6 font-weight-bold" style="line-height: 1.1">
						<v-progress-circular
							v-if="cargando"
							indeterminate
							size="18"
							width="2"
							:color="tarjeta.color"
						/>
						<span v-else>{{ tarjeta.cantidad }}</span>
					</div>
					<div class="kpi__etiqueta text-truncate">{{ tarjeta.texto }}</div>
				</div>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'WorkOrderKpis',
	props: {
		kpis: {
			type: Object,
			default: () => ({ total: 0, certificadas: 0, pendientes: 0, sinFirma: 0 }),
		},
		activo: { type: String, default: 'todas' },
		cargando: { type: Boolean, default: false },
		mostrarFirma: { type: Boolean, default: true },
	},
	computed: {
		tarjetas() {
			const lista = [
				{
					valor: 'todas',
					texto: 'Órdenes',
					cantidad: this.kpis.total || 0,
					color: 'primary',
					icono: 'mdi-file-document-multiple',
				},
				{
					valor: 'pendiente',
					texto: 'Por certificar',
					cantidad: this.kpis.pendientes || 0,
					color: 'warning',
					icono: 'mdi-clock-alert-outline',
				},
				{
					valor: 'certificada',
					texto: 'Certificadas',
					cantidad: this.kpis.certificadas || 0,
					color: 'success',
					icono: 'mdi-check-decagram',
				},
			];
			if (this.mostrarFirma)
				lista.push({
					valor: 'sinFirma',
					texto: 'Sin firma',
					cantidad: this.kpis.sinFirma || 0,
					color: 'error',
					icono: 'mdi-draw-pen',
				});
			return lista;
		},
	},
};
</script>

<style lang="scss" scoped>
.kpis {
	max-width: 1500px;
	margin: 0 auto 4px;
	padding: 0 7px;
}

.kpi {
	cursor: pointer;
	border: 1px solid #cad8dd;
	border-radius: 10px;
	transition: box-shadow 0.15s ease;
	min-height: 58px;

	::v-deep .text-h6 {
		font-size: 20px !important;
		color: #37474f;
	}
}

.kpi:hover {
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.kpi--activo {
	border-width: 2px;
}

.kpi__etiqueta {
	font-size: 12px;
	color: #607d8b;
}
</style>
